import algoliasearch from 'algoliasearch';
import instantsearch from 'instantsearch.js';
import { stats, configure, clearRefinements  } from 'instantsearch.js/es/widgets';
import customHits from './algolia/hits';
import customRefinementList from './algolia/refinementList';
import customPagination from './algolia/pagination';
import customSearchBox from './algolia/searchBox';
import searchBoxIngredient from './algolia/searchBoxIngredient'
import { 
    getCustomRouter, 
    getApiIdentifiant, 
    getFiltres, 
    getSearchFiltres,
    postRequestExist
} from './../../../algolia/helper';

let apiIdentifiant = getApiIdentifiant();
let filtres = getFiltres();
let traduction = getTraductions();
/*
let allergenePost = $('.tematik_recettes').data('allergene');
let modePost = $('.tematik_recettes').data('mode');
let recherchePost = $('.tematik_recettes').data('recherche');
*/
let indexName = getAlgoliaIndex();
const searchClient = algoliasearch(apiIdentifiant.appId, apiIdentifiant.apiId);
const search = instantsearch({
    indexName,
    searchClient,
    routing: getCustomRouter(indexName, getInitialUiState()),
});

let widgetParameters = [
    configure({
        filters: formatFiltres(filtres),
        minWordSizefor1Typo: 1,
    }),
    clearRefinements({
        container: document.querySelector('.clear-refinement'),
        templates: {
            resetLabel({ hasRefinements }) {
                return `<span>${hasRefinements ? traduction.recettes : ''}</span>`;
              },
        }
    }),
    stats({
        container: '.tematik_recettes-compteur',
        templates: {
            text: `
              {{#hasNoResults}}${traduction.state.aucune} {{/hasNoResults}}
              {{#hasOneResult}}1 ${traduction.state.singulier}{{/hasOneResult}}
              {{#hasManyResults}}{{#helpers.formatNumber}}{{nbHits}}{{/helpers.formatNumber}} ${traduction.state.pluriel}{{/hasManyResults}}
            `,
          },
    }),
    customSearchBox({
        container: document.querySelector('.rechercheSimple'),
        placeholder: traduction.searchPlaceholder,
        searchBoxAriaLabel: traduction.searchBoxAriaLabel
    }),
    customHits({
        container: document.querySelector('#listeRecettes'),
    }),
    customRefinementList({
        container: document.querySelector('#content_difficulte'),
        header: document.querySelector('#header_difficulte'),
        attribute: 'difficulte',
    }),
    customRefinementList({
        container: document.querySelector('#content_regimes'),
        header: document.querySelector('#header_regimes'),
        filtres: filtres.modes_de_consommation,
        attribute: 'mode_de_consommation',
    }),
    customRefinementList({
        container: document.querySelector('#content_saisons'),
        header: document.querySelector('#header_saison'),
        filtres: filtres.saisons,
        attribute: 'saison',
    }),
    customRefinementList({
        container: document.querySelector('#content_produits_lies'),
        header: document.querySelector('#header_produits_lies'),
        filtres: filtres.produits_lies,
        attribute: 'produits_lies',
    }),
    customRefinementList({
        container: document.querySelector('#content_continents'),
        header: document.querySelector('#header_continent'),
        filtres: filtres.continent,
        attribute: 'continent',
    }),
    customRefinementList({
        container: document.querySelector('#content_categories'),
        header: document.querySelector('#header_categorie'),
        filtres: filtres.categories,
        attribute: 'categorie',
    }),
    customRefinementList({
        container: document.querySelector('#content_instants'),
        header: document.querySelector('#header_instant'),
        attribute: 'instant',
    }),
    customRefinementList({
        container: document.querySelector('#content_sous_thematiques'),
        header: document.querySelector('#header_sous_thematique'),
        filtres: filtres.sous_thematiques,
        attribute: 'sous_thematique',
    }),
    customRefinementList({
        container: document.querySelector('#content_temps_preparation'),
        header: document.querySelector('#header_temps_preparation'),
        attribute: 'temps_preparation',
    }),
    customPagination({
        container: document.querySelector('#pagination_recette'),
    }),
];

// Ajoute le filtre des ingrédients s'ils est activé
if(document.querySelector('#ingredient-search') !== null) {
    widgetParameters.push(
        searchBoxIngredient({
            container: document.querySelector('#ingredient-search'),
            traduction: traduction.ingredients
        })
    );
}

search.addWidgets(widgetParameters);
search.start();


/**
 * Les stats
 * permet de recupérer les texts des stats
 */
function getTraductions()
{
    let traductions = $('.tematik_recettes').data('traductions');
    return traductions;
}

/**
 * Les index algolia
 * @return String
 * permet de recupérer l'index d'algolia
 */
function getAlgoliaIndex()
{
    let langue = filtres.langue;

    if (langue === 'fr') {
        return 'recettes_fr';
    }

    return 'recettes_en';
}


/**
 * Les filtres formatés pour le filters
 * @return array
 * permet de recupérer filtres formatés pour la mise en place du filters
 */
function formatFiltres(filtres){
    let filtresTab = [];
    //mode de consommation
    if(filtres.modes_de_consommation != ""){
        let filtreModeConsommation = formatFiltresParFacet(filtres.modes_de_consommation, 'mode_de_consommation');
        filtresTab.push(filtreModeConsommation);
    }
    
    //saison 
    if(filtres.saisons != ""){
        let filtreSaison = formatFiltresParFacet(filtres.saisons, 'saison');
        filtresTab.push(filtreSaison);
    }
  

    //continent 
    if(filtres.continent != ""){
        let filtreContinent = formatFiltresParFacet(filtres.continent, 'continent');
        filtresTab.push(filtreContinent);
    }
   

    //sous_thematique
    if(filtres.sous_thematiques != ""){
        let filtreSousThematique = formatFiltresParFacet(filtres.sous_thematiques, 'sous_thematique');
        filtresTab.push(filtreSousThematique);
    }
   

    //categories
    if(filtres.categories != ""){
        let filtreCategorie = formatFiltresParFacet(filtres.categories, 'categorie');
        filtresTab.push(filtreCategorie);
    }
   
    let filtresFormat = filtresTab.join(' AND ');
    return filtresFormat;
}
/**
 * le filtre formaté pour le filters
 * @return array
 * permet de recupérer chaque filtre formatés pour la mise en place du filters
 */
function formatFiltresParFacet(filtres, nomFacet){
    let tab = [];
        filtres.forEach(filtre => {
            if(filtre.indexOf("'") >= 0 ){
                let echap = "\\";
                let position = filtre.indexOf("'");
                filtre = [filtre.slice(0,position), echap, filtre.slice(position)].join('');
            }
            if(filtre.indexOf(' ') >= 0){
                tab.push(nomFacet.concat(':',"'"+filtre+"'"));
            }else{
                tab.push(nomFacet.concat(':',filtre));
            }
        });    
        let filtreFormate = tab.join(' OR ')
   return filtreFormate;
}

/**
 * Mets la liste des recettes avec un champ de recherche defini et des modes de consommations
 *  @return state
 */
function getInitialUiState()
{
    let { recherche, mode_consommation } = getSearchFiltres();
    let index = getAlgoliaIndex();
    if (!recherche && !mode_consommation) {
        return {[index]: {}};
    }

    let state = {
        [index]: {
            query: recherche,
            mode_de_consommation: mode_consommation ? [mode_consommation] : [],
        }
    }


    return state;
}
